var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpbnbTestnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_2441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8365 32 32 24.8365 32 16C32 7.16344 24.8365 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8365 7.16344 32 16 32Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79671 16.0002L8.80825 20.2309L12.4031 22.3463V24.8232L6.7044 21.481V14.763L8.79671 16.0002ZM8.79671 11.7694V14.2348L6.70312 12.9963V10.5309L8.79671 9.29248L10.9005 10.5309L8.79671 11.7694ZM13.9044 10.5309L15.998 9.29248L18.1018 10.5309L15.998 11.7694L13.9044 10.5309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3047 19.3541V16.8771L12.3983 18.1155V20.581L10.3047 19.3541ZM13.8996 23.2335L15.9932 24.472L18.097 23.2335V25.6989L15.9932 26.9373L13.8996 25.6989V23.2335ZM21.0996 10.5309L23.1932 9.29248L25.297 10.5309V12.9963L23.1932 14.2348V11.7694L21.0996 10.5309ZM23.1932 20.2309L23.2047 16.0002L25.2983 14.7617V21.4797L19.5996 24.8219V22.345L23.1932 20.2309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6952 19.3538L19.6016 20.5808V18.1154L21.6952 16.877V19.3538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6919 12.6463L21.7034 15.1232L18.0983 17.2386V21.4797L16.0047 22.7066L13.9111 21.4797V17.2386L10.306 15.1232V12.6463L12.4085 11.4079L15.9919 13.5335L19.597 11.4079L21.7008 12.6463H21.6919ZM10.3047 8.41683L15.9932 5.06299L21.6919 8.41683L19.5983 9.65529L15.9932 7.52964L12.3983 9.65529L10.3047 8.41683Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_2441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpbnbTestnet);
export default __webpack_public_path__ + "static/media/opbnb-testnet.4c19f3ee2bfc317c4a6456e157ebceb7.svg";
export { ForwardRef as ReactComponent };